import { NextPageContext } from "next";
import nookies from "nookies";

export const werePreferencesAlreadySetWithBorlabs = (
  ctx?: NextPageContext
): boolean => {
  // Return whether cookie preferences have already been set from WordPress
  // via the cookie banner implemented with the Borlabs Cookie WP plugin.
  // If this function returns true, then the caller can decide to not show
  // the cookie banner, as the only cookie that is actually useful (GA)
  // has already been accepted or denied on WordPress by the user.
  try {
    const consents = borlabsCookieConsents(ctx);
    return (
      "essential" in consents &&
      Array.isArray(consents.essential) &&
      consents.essential.includes("borlabs-cookie")
    );
  } catch {
    return false;
  }
};

export const wereAnalyticsAlreadyAcceptedWithBorlabs = (
  ctx?: NextPageContext
): boolean => {
  // Return whether Google Analytics has already been accepted from WordPress
  // via the cookie banner implemented with the Borlabs Cookie WP plugin.
  // If this function returns true, then the caller can decide to set up
  // Google Tag Manager.
  try {
    const consents = borlabsCookieConsents(ctx);
    return (
      "marketing" in consents &&
      Array.isArray(consents.marketing) &&
      consents.marketing.includes("google-tag-manager")
    );
  } catch {
    return false;
  }
};

const borlabsCookieConsents = (ctx?: NextPageContext): object => {
  // Return the Borlabs cookie consent values.
  try {
    const borlabsCookieString = nookies.get(ctx)["borlabs-cookie"];
    const borlabsCookie = JSON.parse(decodeURIComponent(borlabsCookieString));
    if (
      typeof borlabsCookie === "object" &&
      "consents" in borlabsCookie &&
      typeof borlabsCookie.consents === "object"
    ) {
      return borlabsCookie.consents;
    } else {
      return {};
    }
  } catch {
    return {};
  }
};
